var _isFF = false;
var _isIE = false;
var _isOpera = false;
var _isKHTML = false;
var _isMacOS = false;
var _isChrome = false;
var _FFrv = false;
var _KHTMLrv = false;
var _OperaRv = false;
if (navigator.userAgent.indexOf("Macintosh") != -1) {
    _isMacOS = true;
}
if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
    _isChrome = true;
}
if (navigator.userAgent.indexOf("Safari") != -1 ||
    navigator.userAgent.indexOf("Konqueror") != -1) {
    _KHTMLrv = parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Safari") + 7, 5));
    if (_KHTMLrv > 525) {
        _isFF = true;
        _FFrv = 1.9;
    } else {
        _isKHTML = true;
    }
} else {
    if (navigator.userAgent.indexOf("Opera") != -1) {
        _isOpera = true;
        _OperaRv = parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Opera") + 6, 3));
    } else {
        if (navigator.appName.indexOf("Microsoft") != -1) {
            _isIE = true;
            if ((navigator.appVersion.indexOf("MSIE 8.0") != -1 ||
                navigator.appVersion.indexOf("MSIE 9.0") != -1 ||
                navigator.appVersion.indexOf("MSIE 10.0") != -1 ||
                document.documentMode > 7) &&
                document.compatMode != "BackCompat") {
                _isIE = 8;
            }
        } else {
            if (navigator.appName == "Netscape" &&
                navigator.userAgent.indexOf("Trident") != -1) {
                _isIE = 8;
            } else {
                _isFF = true;
                _FFrv = parseFloat(navigator.userAgent.split("rv:")[1]);
            }
        }
    }
}



export {_isFF, _isIE, _isOpera, _isKHTML, _isMacOS, _isChrome, _FFrv, _OperaRv};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/commonUtils.js